"use strict";

var _regeneratorRuntime = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilePicker = void 0;

var tslib_1 = require("tslib"); // @ts-nocheck


var react_1 = require("react");

var axios_1 = tslib_1.__importDefault(require("axios"));

var react_apollo_1 = require("react-apollo");

var react_dropzone_1 = require("react-dropzone");

var useFilePicker_constants_1 = require("./useFilePicker.constants");

var useFilePicker_gql_1 = require("./useFilePicker.gql");

var uploadFile = function uploadFile(uploadUrl, file, onProgress) {
  return axios_1.default.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type
    }
  });
};

var useFilePicker = function useFilePicker(_ref) {
  var uploadCallback = _ref.uploadCallback,
      controlledValue = _ref.controlledValue,
      onChange = _ref.onChange;

  var _ref2 = (0, react_1.useState)([]),
      _ref3 = _slicedToArray(_ref2, 2),
      fileList = _ref3[0],
      setFileList = _ref3[1];

  var _ref4 = (0, react_1.useState)([]),
      _ref5 = _slicedToArray(_ref4, 2),
      fileProgressList = _ref5[0],
      setFileProgressList = _ref5[1];

  var _ref6 = (0, react_1.useState)(false),
      _ref7 = _slicedToArray(_ref6, 2),
      isOpen = _ref7[0],
      setOpen = _ref7[1];

  var _ref8 = (0, react_1.useState)(useFilePicker_constants_1.STEPS.select),
      _ref9 = _slicedToArray(_ref8, 2),
      step = _ref9[0],
      setStep = _ref9[1];

  var _ref10 = (0, react_apollo_1.useMutation)(useFilePicker_gql_1.FILE_PICKER__CREATE_FILE_MUTATION),
      _ref11 = _slicedToArray(_ref10, 1),
      createFile = _ref11[0];

  var _ref12 = (0, react_1.useState)({}),
      _ref13 = _slicedToArray(_ref12, 2),
      options = _ref13[0],
      setOptions = _ref13[1];

  var _ref14 = (0, react_1.useState)(controlledValue),
      _ref15 = _slicedToArray(_ref14, 2),
      value = _ref15[0],
      setValue = _ref15[1];

  var _ref16 = (0, react_1.useState)(null),
      _ref17 = _slicedToArray(_ref16, 2),
      originalFile = _ref17[0],
      setOriginalFile = _ref17[1];

  var _ref18 = (0, react_1.useState)(null),
      _ref19 = _slicedToArray(_ref18, 2),
      error = _ref19[0],
      setError = _ref19[1];

  (0, react_1.useEffect)(function () {
    setValue(controlledValue);
  }, [controlledValue]);
  var addFiles = (0, react_1.useCallback)(function (files, rejectedFiles) {
    if (rejectedFiles && rejectedFiles.length > 0) {
      alert('You select invalid quantity of images or one or more images have a invalid format.');
      setStep(useFilePicker_constants_1.STEPS.select);
    } else {
      var filesWithLocalPath = files.map(function (file) {
        if (file.type.includes('image')) {
          return Object.assign(file, {
            localPath: URL.createObjectURL(file)
          });
        }

        return Object.assign(file, {
          localPath: undefined
        });
        ;
      });

      var newList = _toConsumableArray(fileList).concat(_toConsumableArray(filesWithLocalPath));

      if (options && options.maxFiles) {
        newList = newList.slice(0, options.maxFiles);
      }

      setFileList(newList);
      setStep(useFilePicker_constants_1.STEPS.upload);
    }
  }, [fileList, options]);

  var _ref20 = (0, react_dropzone_1.useDropzone)({
    onDrop: addFiles,
    accept: options && options.accept ? options.accept : undefined,
    maxFiles: options && options.maxFiles ? options.maxFiles : undefined,
    maxSize: options && options.maxSize ? options.maxSize : undefined
  }),
      getRootProps = _ref20.getRootProps,
      getInputProps = _ref20.getInputProps;

  var showFilePicker = (0, react_1.useCallback)(function () {
    var pickerOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setOptions(pickerOptions);
    setFileList([]); //setValue(null);

    setError(null);
    setOriginalFile(null);
    setStep(useFilePicker_constants_1.STEPS.select);
    setOpen(true);
  }, []);
  var hideFilePicker = (0, react_1.useCallback)(function () {
    if (step === useFilePicker_constants_1.STEPS.uploading) {
      return null;
    }

    if (step === useFilePicker_constants_1.STEPS.select) {
      setError(null);
    }

    setFileList([]);
    setStep(useFilePicker_constants_1.STEPS.select);
    setOpen(false);
  }, [step]);
  var setUploadMoreStep = (0, react_1.useCallback)(function () {
    setStep(useFilePicker_constants_1.STEPS.uploadMore);
  }, []);
  var setUploadStep = (0, react_1.useCallback)(function () {
    setStep(useFilePicker_constants_1.STEPS.upload);
  }, []);
  var removeFile = (0, react_1.useCallback)(function (file) {
    return function () {
      var newFileList = _toConsumableArray(fileList);

      var indexToRemove = newFileList.indexOf(file);

      if (indexToRemove !== -1) {
        newFileList.splice(indexToRemove, 1);

        if (newFileList.length === 0) {
          setStep(useFilePicker_constants_1.STEPS.select);
        }

        setFileList(_toConsumableArray(newFileList));
      }
    };
  }, [fileList]);
  var onProgress = (0, react_1.useCallback)(function (list) {
    var currentList = _toConsumableArray(list);

    return function (index) {
      return function (progress) {
        var newList = _toConsumableArray(currentList);

        console.log(newList);
        newList[index] = progress;
        currentList = _toConsumableArray(newList);
        setFileProgressList(newList);
      };
    };
  }, []);
  var handleUploadDone = (0, react_1.useCallback)(function (filesUploaded, file) {
    //console.log("🚀 ~ newValue:", filesUploaded)
    var newValue = _toConsumableArray(filesUploaded); //console.log("🚀 ~ newValue:", newValue)


    var newOriginalFile = _toConsumableArray(file); //console.log("🚀 ~ newOriginalFile:", newOriginalFile)


    var maxFiles = options.maxFiles; //console.log("🚀 ~ newOriginalFile:", maxFiles)
    //console.log("🚀 ~ options:", options)

    if (maxFiles === 1) {
      newValue = newValue[0];
      newOriginalFile = newOriginalFile[0];
    }

    setValue(newValue);
    setOriginalFile(newOriginalFile);

    if (typeof uploadCallback === 'function') {
      uploadCallback && uploadCallback(newValue, newOriginalFile);
    }

    if (typeof onChange === 'function') {
      onChange(newValue, newOriginalFile);
    }

    hideFilePicker();
  }, [options, uploadCallback, hideFilePicker]);
  var upload = (0, react_1.useCallback)(function (useFilestack, workspace, apiKey, uploadHost, environment) {
    var newProgressList = fileList.map(function (el) {
      return 0;
    });
    setFileProgressList(newProgressList);
    setStep(useFilePicker_constants_1.STEPS.uploading);

    if (fileList.length === 0) {
      hideFilePicker();
    }

    var uploadedFileList = [];
    var failedFileList = [];
    var uploadedOriginalFileList = [];
    var handleProgress = onProgress(newProgressList);
    var loadFiles = fileList.map(function (file, index) {
      var formdata = new FormData();

      if (useFilestack) {
        return createFile({
          variables: {
            data: {
              filename: file.name
            }
          }
        }).then(function (_ref21) {
          var data = _ref21.data;
          return tslib_1.__awaiter(void 0, void 0, void 0,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var _data$fileCreate, id, uploadUrl, downloadUrl, fileId, filename, isPublic, res;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _data$fileCreate = data.fileCreate, id = _data$fileCreate.id, uploadUrl = _data$fileCreate.uploadUrl, downloadUrl = _data$fileCreate.downloadUrl, fileId = _data$fileCreate.fileId, filename = _data$fileCreate.filename, isPublic = _data$fileCreate.public;
                    _context.next = 3;
                    return uploadFile(uploadUrl, file, handleProgress(index));

                  case 3:
                    res = _context.sent;

                    if (res.status === 200) {
                      uploadedFileList.push({
                        id: id,
                        downloadUrl: downloadUrl,
                        fileId: fileId,
                        filename: filename,
                        mimetype: file.type,
                        public: isPublic
                      });
                      uploadedOriginalFileList.push(file);
                    } else {
                      failedFileList.push({
                        id: id,
                        downloadUrl: downloadUrl,
                        fileId: fileId,
                        filename: filename,
                        mimetype: file.type,
                        public: isPublic
                      });
                    }

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        });
      } else {
        formdata.append('files', file, file.name);
        return axios_1.default.post(uploadHost + '/upload', formdata, {
          headers: {
            'authorization': apiKey,
            'workspace': workspace,
            'environment': environment,
            'storage-provider': 'S3'
          }
        }).then(function (response) {
          if (response.status === 200) {
            response.data.data.forEach(function (element) {
              uploadedFileList.push(element);
            }); // uploadedFileList.push({
            //   id: response.data.data[0].fileId,
            //   downloadUrl: response.data.data[0].downloadUrl,
            //   fileId: response.data.data[0].fileId,
            //   filename: response.data.data[0].filename,
            //   mimetype: file.type,
            //   public: response.data.data[0].public,
            // });
          } else {
            console.log('uploaded file with error', file);
          }
        }).catch(function (error) {
          setError(error.response.data.error);
          setStep(useFilePicker_constants_1.STEPS.error);
        });
      }
    });
    Promise.all(loadFiles).then(function () {
      return handleUploadDone(uploadedFileList, uploadedOriginalFileList);
    }).catch(setError);
  }, [createFile, fileList, hideFilePicker, onProgress, handleUploadDone]);
  return {
    fileList: fileList,
    fileProgressList: fileProgressList,
    setFileList: setFileList,
    isOpen: isOpen,
    hideFilePicker: hideFilePicker,
    showFilePicker: showFilePicker,
    addFiles: addFiles,
    removeFile: removeFile,
    step: step,
    setStep: setStep,
    setUploadMoreStep: setUploadMoreStep,
    setUploadStep: setUploadStep,
    upload: upload,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    options: options,
    value: value,
    originalFile: originalFile,
    error: error
  };
};

exports.useFilePicker = useFilePicker;